import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import Balancer from 'react-wrap-balancer';

import { addUser } from '~features/user/ducks';
import * as api from '~services/api';

import Dropdown from '../../../components/tasklist/components/Dropdown';

import cancelIcon from '~images/Ruksi_ikoni_valkoinen.svg';

const ProfileUnitChange = ({
  user,
  userOrganizations,
  onUnitSelect,
  activeUnit,
}) => {
  const dispatch = useDispatch();

  const handleCcAcknowledgement = async () => {
    try {
      const user = await api.put('users/me/ccAcknowledgement', {});
      dispatch(addUser(user));
    } catch (e) {
      console.error('Error in handleCcAcknowledgement', e);
    }
  };

  return (
    <Wrapper>
      <SelectWrapper>
        <Control>
          <Dropdown
            options={userOrganizations.map(org => ({
              key: org.id,
              value: org.id,
              label: org.name,
            }))}
            value={activeUnit ? activeUnit.id : ''}
            onChange={value => {
              onUnitSelect(value);
            }}
            secondary
          />
        </Control>
      </SelectWrapper>
      {user?.showCcNotification && (
        <CcNotificationWrapper>
          <CcNotification>
            <CcNotificationIndicator />
            <CcNotificationText>
              <Balancer>
                Tarkistathan, että tämä on yksikkösi, jossa työskentelet. Mikäli
                työskentelet jossain muussa yksikössä, voit valita yksikön
                yllä&shy;olevasta listasta. Jos todellinen yksikkösi ei löydy
                listalta, paina ‘En löydä yksikköäni’ alta kysyäksesi apua
                palvelu&shy;koordinaattoreilta.
              </Balancer>
            </CcNotificationText>
          </CcNotification>
          <CcNotificationCancelIcon
            alt="Piilota ilmoitus"
            src={cancelIcon}
            onClick={handleCcAcknowledgement}
          />
        </CcNotificationWrapper>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
`;

const SelectWrapper = styled.div`
  position: relative;
  width: 100%;
  margin: 0;
`;

const Control = styled.div`
  flex-grow: 1;
`;

const CcNotificationWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
`;

const CcNotification = styled.div`
  background-color: #0c244f;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  border-radius: 4px;
`;

const CcNotificationIndicator = styled.div`
  width: 12px;
  height: 12px;
  margin-top: 3px;
  background-color: #ff8492;
  border-radius: 100%;
  margin-right: 8px;
  flex-shrink: 0;
`;

const CcNotificationText = styled.div`
  color: white;
  flex-shrink: 1;
  line-height: 1.3rem;
`;

const CcNotificationCancelIcon = styled.img`
  width: 11px;
  cursor: pointer;
  margin-left: 12px;
  margin-right: -5px;
`;

export default ProfileUnitChange;
